// extracted by mini-css-extract-plugin
export default {"link":"o5Xlx3K9c7","link-active":"iAnMjpMfVb","linkActive":"iAnMjpMfVb","icon":"tJtXKM-Wib"};